import _extends from "@babel/runtime-corejs3/helpers/extends";
var _path;
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
const Checked = ({
  ...rest
}) => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement(SvgIcon, _extends({
  component: "rect",
  width: "20",
  height: "20",
  rx: "5",
  ry: "5",
  lx: "5",
  ly: "5"
}, rest)), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5528 15.79C10.3684 15.79 10.1993 15.7286 10.061 15.5902L7.00241 12.5316C6.72576 12.255 6.72576 11.8246 7.00241 11.548C7.27907 11.2713 7.70941 11.2713 7.98607 11.548L10.5682 14.1147L16.7008 7.99753C16.9774 7.72087 17.4078 7.72087 17.6845 7.99753C17.9611 8.27419 17.9611 8.70455 17.6845 8.9812L11.06 15.5902C10.9063 15.7286 10.7373 15.79 10.5528 15.79Z",
  fill: "white"
})));
export default Checked;